import { render, staticRenderFns } from "./Accountmingxi.vue?vue&type=template&id=31d832c7&scoped=true"
import script from "./Accountmingxi.vue?vue&type=script&lang=js"
export * from "./Accountmingxi.vue?vue&type=script&lang=js"
import style0 from "./Accountmingxi.vue?vue&type=style&index=0&id=31d832c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d832c7",
  null
  
)

export default component.exports